import { render } from "./AddComponent.vue?vue&type=template&id=0ed7afe4"
import script from "./AddComponent.vue?vue&type=script&lang=js"
export * from "./AddComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__